module.exports = __webpack_public_path__ + "static/img/图片1.51e2dc9e.png";